import '../chart_view.js.coffee'
Monitoring.Views.Charts ||= {}

class Monitoring.Views.Charts.StackedHorizontalBarChartView extends Backbone.View
  template: JST['backbone/templates/monitoring/charts/stacked_horizontal_bar_chart']
  height: '12px'
  className: 'float width100Percent'

  initialize: (@options = {}) ->
    @data = @calculatePercentages(@options.data)

  render: ->
    @$el.html @template
      title: @title
      data: @data
    @

  calculatePercentages: (data) ->
    total = _.reduce(data, ((acum, data) -> acum + parseFloat(data.y)), 0)
    _.each(data, (serie) ->
      serie.ptc = if total > 0 then Math.trunc((parseFloat(serie.y) / total) * 10000)/100 else 0
    )
